import Column from '@app/components/layout/Column'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'
import { lazy, Suspense } from 'react'
import { Contact } from './Contact'

const SingleMarkerMap = lazy(() =>
  import('@app/components/core/map/SingleMarkerMap').then((module) => ({
    default: module.SingleMarkerMap,
  })),
)

const MapComponent = ({
  serviceProvider,
}: {
  serviceProvider: ServiceProviderViewModel
}) => {
  if (!serviceProvider) {
    return null
  }

  const lat = serviceProvider.location?.geo?.lat
  const long = serviceProvider.location?.geo?.long

  if (typeof lat !== 'number' || typeof long !== 'number') {
    return null
  }

  return (
    <Suspense fallback={null}>
      <SingleMarkerMap
        lat={lat}
        long={long}
        marker="pin"
        zoom={15}
        height="300px"
      />
    </Suspense>
  )
}

export const RightColumn = ({
  serviceProvider,
}: {
  serviceProvider: ServiceProviderViewModel
}) => {
  return (
    <Column style={{ flex: '0 1 23rem', minWidth: '23rem' }}>
      <MapComponent serviceProvider={serviceProvider} />
      <Contact serviceProvider={serviceProvider} />
    </Column>
  )
}
